import { SpinTheWheelPage } from "../pages/SpinTheWheelPage";
import { ChooseSpinnerPage } from "../pages/ChooseSpinnerPage";
import { EditSpinnerPage } from "../pages/EditSpinnerPage";
import { AddSpinnerPage } from "../pages/AddSpinnerPage";
import { LoginPage } from "../pages/LoginPage";
import { States } from "../App";

export function MainContent({
  state,
  setState,
  spinnerList,
  chooseSpinner,
  deleteSpinner,
  createSpinner,
  spinnerEntries,
  addNewEntry,
  deleteEntry,
  toggleEntryVisible,
  hideCheckedEntries,
  login,
}) {
  const mainContent = [];
  mainContent.push(
    <SpinTheWheelPage
      key={0}
      spinnerValues={
        spinnerEntries.map((entry) => ({
          text: entry.entry,
          visible: entry.visible,
        })) ?? []
      }
      setState={setState}
    />,
  );

  if (state === States.ChooseSpinner) {
    mainContent.push(
      <ChooseSpinnerPage
        key={1}
        spinnerList={spinnerList}
        chooseSpinner={chooseSpinner}
        deleteSpinner={deleteSpinner}
      />,
    );
  } else if (state === States.EditSpinner) {
    mainContent.push(
      <EditSpinnerPage
        key={2}
        spinnerEntries={spinnerEntries}
        addNewEntry={addNewEntry}
        deleteEntry={deleteEntry}
        toggleEntryVisible={toggleEntryVisible}
        setState={setState}
        hideCheckedEntries={hideCheckedEntries}
      />,
    );
  } else if (state === States.AddSpinner) {
    mainContent.push(<AddSpinnerPage key={3} createSpinner={createSpinner} />);
  } else if (state === States.Login) {
    mainContent.push(<LoginPage key={4} login={login} />);
  }

  return mainContent;
}
